module.exports = __webpack_public_path__ + "static/media/img-products-greet.870eb1a7.png";